import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ub7whnp6m: FaireProductEntity = {
  token: "p_9ub7whnp6m",
  type: "product",
  name: "Mommy Needs A Cigarette Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/e1c4f5c4496dcb0831b65e1c0ce99e15a7e2812b01438827c18160305431e6fa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b9690f8114496b37b5d884941f4f5cec941f10bad9361e5873541c0c0c316915.jpeg",
    "https://cdn.faire.com/fastly/cee17a116d8818be4920093c8884f9671e1ea7ed26858e8d2b292703be1a4d1c.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/f7d10ed78fcf2e274221fe15833d04889597b5b796295225bff42590283c2ae9.jpeg",
    "https://cdn.faire.com/fastly/c6764f0a05e015727618f6afa9bb98a858f7c70d8f8b386ba979b1c5c1f29c65.jpeg"
  ],
  priceDollars: 6.75,
  description: "Mommies have needs too! For surviving tantrums, whining, playdates, and just... so much poop and pee. The kids may never slow down, but your feet can still be comfortable. You deserve a medal, but you can't smoke those. 🤷\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:56.392Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
